var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Coupon',
        to: {
          name: 'coupon'
        }
      }, {
        label: this.name
      }],
      "title": this.name
    }
  }), _c('div', {
    staticClass: "bg-white p-4 my-3 rounded-lg shadow-sm"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_vm._m(0), _c('div', [_c('button', {
    staticClass: "bg-blue-700 mx-2 px-2.5 py-1.5 text-white rounded-lg"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('svg', {
    staticClass: "dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z",
      "clip-rule": "evenodd"
    }
  })]), _c('router-link', {
    staticClass: "text-white w-full block list-none ml-2 mt-0",
    attrs: {
      "to": {
        path: ("/coupon/edit/" + (this.$route.params.id))
      }
    }
  }, [_c('span', {
    staticClass: "mt-0"
  }, [_vm._v("Edit")])])], 1)])])]), _c('div', {
    staticClass: "flex justify-start mt-2"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Coupon Name")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.name))])])]), _c('div', {
    staticClass: "block mt-2 w-full"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Description")]), _c('div', {
    staticClass: "block w-full relative pr-4"
  }, [_c('p', {
    staticClass: "text-gray-600 transition-all duration-300 m-0 overflow-hidden",
    class: {
      'h-20 transition-all': !_vm.showFullText,
      'h-10 transition-all': this.description < 50
    }
  }, [_vm._v(" " + _vm._s(this.description) + " ")]), this.description.length > 150 ? _c('button', {
    staticClass: "text-gray-800 font-semibold mt-1 float-right",
    on: {
      "click": _vm.toggleReadMore
    }
  }, [_c('span', {
    staticClass: "flex items-center"
  }, [_vm._v(" " + _vm._s(!_vm.showFullText ? "Read More " : "Read Less ") + " "), !_vm.showFullText ? _c('svg', {
    staticClass: "w-5 h-5 text-gray-800 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "m19 9-7 7-7-7"
    }
  })]) : _vm._e(), _vm.showFullText ? _c('svg', {
    staticClass: "w-5 h-5 text-gray-800 dark:text-white",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "m5 15 7-7 7 7"
    }
  })]) : _vm._e()])]) : _vm._e()])]), _c('div', {
    staticClass: "flex justify-betweens mt-2 w-full"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Client/Buyer Name")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.client_name))])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Start Date")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.formatDate(this.start_date)))])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Platform")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(" " + _vm._s(this.platforms))])])])]), _c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Coupon Price")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(_vm.formatCurrency(this.price, 'IDR')))])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("End Date")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.formatDate(this.end_date)))])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Product/Offer to Be Redeemed")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.offer_name))])])])])])]), _c('div', {
    staticClass: "w-1/2"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "block"
  }, [this.status ? _c('span', {
    staticClass: "text-green-800 bg-green-100 font-semibold px-2.5 py-1 rounded-lg"
  }, [_vm._v("Active")]) : _c('span', {
    staticClass: "text-gray-800 bg-gray-100 font-semibold px-2.5 py-1 rounded-lg"
  }, [_vm._v(" Inactive ")])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v("Created Date")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.formatDate(this.created)))])])]), _c('div', {
    staticClass: "block mt-2"
  }, [_c('label', {
    staticClass: "text-gray-800 text-base font-semibold mb-1"
  }, [_vm._v(" Last Modified Date")]), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v(_vm._s(this.formatDate(this.modified)))])])])])])]), _c('div', {
    staticClass: "bg-white p-4 my-4 rounded-lg shadow-sm"
  }, [_c('h4', {
    staticClass: "text-gray-900 font-semibold text-xl mb-4"
  }, [_vm._v("Coupon Code Details")]), _c('div', {
    staticClass: "flex justify-between items-center align-middle mb-4"
  }, [_c('div', {
    staticClass: "block relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter,
      expression: "filter"
    }],
    staticClass: "bg-gray-100 rounded-lg py-2 px-4 border w-96",
    attrs: {
      "placeholder": "Search Coupon Code & Reedemed By"
    },
    domProps: {
      "value": _vm.filter
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value;
      }, _vm.searchByCodeCoupon]
    }
  }), _vm.filter ? _c('button', {
    staticClass: "absolute top-1/2 right-5 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.actionReset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e(), !_vm.filter ? _c('svg', {
    staticClass: "w-6 h-6 text-gray-500 dark:text-white absolute top-1.5 right-3",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      "d": "m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "button_donwload"
  }, [_c('button', {
    staticClass: "bg-blue-700 rounded-lg px-4 py-2 text-white flex justify-between",
    class: {
      'opacity-50 pointer-events-none': _vm.couponscode.length === 0
    },
    on: {
      "click": _vm.downloadCSV
    }
  }, [_c('svg', {
    staticClass: "w-5 h-5 text-white dark:text-white mr-2",
    attrs: {
      "aria-hidden": "true",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
    }
  })]), _vm._v(" Download as CSV ")])])]), _c('div', {
    staticClass: "w-full"
  }, [_c('TableCoupontCode', {
    attrs: {
      "currentpage": _vm.currentPage,
      "perpage": _vm.perPage,
      "couponcode": _vm.couponscode,
      "isLoading": _vm.isLoading
    }
  })], 1), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center mt-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h4', {
    staticClass: "text-gray-900 font-semibold text-xl"
  }, [_vm._v("Coupon Details")])]);
}]

export { render, staticRenderFns }